import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import {Meta} from "@angular/platform-browser";

@Injectable({ providedIn: 'root' })
export class SeoService {
  private renderer: Renderer2;

  constructor(
    private rendererFactory: RendererFactory2,
    @Inject(DOCUMENT) private document: Document,
    private meta: Meta
  ) {
    this.renderer = rendererFactory.createRenderer(this.document, null);
  }

  updateCanonicalUrl(newUrl: string): void {
    const head = this.document.head;
    let linkEl = this.document.querySelector('link[rel="canonical"]');

    if (!linkEl) {
      linkEl = this.renderer.createElement('link');
      this.renderer.setAttribute(linkEl, 'rel', 'canonical');
      this.renderer.appendChild(head, linkEl);
    }
    this.renderer.setAttribute(linkEl, 'href', newUrl);
  }


  addAmpUrl(newUrl: string){
    // <link rel="amphtml" href="https://site.com/article/articleName/amp">


    const head = this.document.head;
    let linkEl = this.document.querySelector('link[rel="amphtml"]');

    if (!linkEl) {
      linkEl = this.renderer.createElement('link');
      this.renderer.setAttribute(linkEl, 'rel', 'amphtml');
      this.renderer.appendChild(head, linkEl);
    }
    this.renderer.setAttribute(linkEl, 'href', newUrl);
  }

  addPreConnect(newUrl: string){

    const head = this.document.head;
    let linkEl = this.document.querySelector('link[rel="preconnect"]');

    if (!linkEl) {
      linkEl = this.renderer.createElement('link');
      this.renderer.setAttribute(linkEl, 'rel', 'preconnect');
      this.renderer.appendChild(head, linkEl);
    }
    this.renderer.setAttribute(linkEl, 'href', newUrl);
  }


  addGoogleAnalytics(trackingId: string) {
    const head = this.document.head;

    const scriptGA = this.renderer.createElement('script');
    scriptGA.async = true;
    scriptGA.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;

    this.renderer.appendChild(head, scriptGA);

    const inlineScript = this.renderer.createElement('script');
    inlineScript.text = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${trackingId}');
    `;
    this.renderer.appendChild(head, inlineScript);

  }



  addYandexMetrika(counterId: string) {
    const head = this.document.head;
    const body = this.document.body;

    const scriptYM = this.renderer.createElement('script');
    scriptYM.type = 'text/javascript';
    scriptYM.text = `
       (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
        m[i].l=1*new Date();
        for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
        k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
      (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

      ym(${counterId}, "init", {
        clickmap:true,
        trackLinks:true,
        accurateTrackBounce:true,
        webvisor:true
      });
    `;
    this.renderer.appendChild(head, scriptYM);


    const noscript = this.renderer.createElement('noscript');
    noscript.innerHTML = `
    <div>
      <img src="https://mc.yandex.ru/watch/${counterId}" style="position:absolute; left:-9999px;" alt="" />
    </div>
  `;
    this.renderer.appendChild(body, noscript);
  }

  removeExistingScripts() {
    const scripts = this.document.querySelectorAll('script[src*="googletagmanager"], script[src*="mc.yandex.ru"]');
    scripts.forEach(script => script.remove());
  }


  addYandexVerification(id:string) {
    this.meta.addTag({name:"yandex-verification", content:id})
  }

}
